(function() {


    angular
    .module('meanApp')
    .service('tagService', tagService);
  
    tagService.$inject = [];
      function tagService () {
          
        var MATCHING_WORDING = {
            fast : 'Rapide',
            complicated : 'Élaboré',
            protein : 'Hyperprotéiné',
            cold : 'Froid',
            eco : 'Économique',
            lowcarb : 'Peu de glucides',
            nopig : 'Sans porc',
            vegan : 'Végétalien',
            paleo : 'Paléo',
            vegetarian : 'Végétarien',
            nogluten : 'Sans gluten',
            nooven : 'Sans four',
            maincourse : 'Plat de résistance',
            nomicrowave : 'Sans micro-ondes',
            entry : 'Entrée',
            pleasure : 'Plaisir',
            savory : 'Salé',
            aperitif : 'Apéro',
            lowcalory : 'Hypocalorique',
            dessert : 'Dessert',
            fast : 'Rapide',
            sweet : 'Sucré',
            hot : 'Chaud',
            local : 'Local',
            season : 'De saison',
            nohob : 'Sans plaque de cuisson'
        },
        DESCRIPTIONS = {
            fast : 'Vous souhaitez cuisiner et garder le contrôle sur ce que vous mangez mais manquez de temps ? Ce Nutritag est fait pour vous ! Il caractérise toutes les recettes prenant moins de 15 min.',
            complicated : 'Vous souhaitez réaliser une cuisine plus élaborée ? Plus complexe ? Epater vos invités ? Ce Nutritag répertorie toutes les recettes représentant une certaine complexité (nombre d’ingrédients élevés, beaucoup d’instructions)',
            protein : 'Les recettes ciblées par ce Nutritag ont une quantité de protéines bien au-dessus de la moyenne. Parfait pour les personnes suivant un régime hyperprotéiné, permettant d’allier prise de muscles et/ou perte de poids. A compléter avec un nutriscore élevé afin d’en augmenter l’efficacité',
            cold : 'Les recettes proposées par ce Nutritag vous apporteront une sensation de fraîcheur. Idéal pour affronter les grosses chaleurs !',
            eco : 'Vous préférez investir votre argent dans un projet personnel plutôt que dans l’alimentation ? Ce Nutritag sélectionnant les recettes les plus économiques est fait pour vous ! Vive les économies !',
            lowcarb : 'Ce Nutritag identifie les recettes hypoglucidiques, elles contiennent en proportion peu de glucides. De nombreux régimes adoptent cette stratégie et promettent de perdre du poids rapidement',
            nopig : 'Les recettes proposées par ce Nutritag ne contiendront aucun ingrédient à base de porc',
            vegan : 'A l’aide de ce Nutritag vous trouverez l’ensemble des recettes excluant tout produit animal',
            paleo : 'Le régime paléolithique ou plus simplement régime paléo, consiste à ne consommer que des aliments disponibles à l’époque du paléolithique. Ce régime, ou philosophie, a pour but de faire perdre du poids mais aussi d’éliminer naturellement tous les aliments transformés de l’industrie agroalimentaire, produits laitiers, céréales. Ceux-ci seraient moins bien assimilés par le corps humain, non adapté',
            vegetarian : 'Que ce soit par conviction ou dans un souci de bien-être physique, découvrez au travers de ce Nutritag des recettes qui excluent toute chaire animale',
            nogluten : 'Les recettes proposées par ce Nutritag excluent tout aliment contenant du gluten',
            nooven : 'Vous n’avez pas de four ? Ou souhaitez cuisiner de façon éco-responsable ? Ce Nutritag vous propose des recettes sans four',
            maincourse : 'Ce tag cible uniquement les recettes catégorisées en tant que plat principal',
            nomicrowave : 'Vous n’avez pas de micro-ondes ? Ce Nutritag vous propose des recettes sans micro-ondes',
            entry : 'Ce Nutritag cible uniquement les recettes catégorisées en tant qu’entrée',
            pleasure : 'Vous souhaitez vous faire plaisir ? Le corps humain adore le gras, le sucre, et le sel ! Les recettes ayant un nutriscore très faible seront donc favorisées',
            savory : 'Plutôt salé ou sucré ? Ce Nutritag s’applique à toute recette ayant une certaine quantité de sel',
            aperitif : "Ce Nutritag identifie toutes les recettes pouvant être réalisées juste avant un repas, au moment de \"l'apéro\". Vous retrouverez des amuse-gueules, tapas, idées de cocktails...",
            lowcalory : 'Ce Nutritag cible les recettes ayant un indice calorique faible. Très utile pour les personnes ayant une santé nécessitant un amaigrissement. Attention, un risque en déficit de micronutriments ou de fonte musculaire est possible à long terme avec ce type de régime',
            dessert : 'Ce Nutritag cible uniquement les recettes catégorisées en tant que dessert',
            sweet : 'Plutôt salé ou sucré ? Ce Nutritag s’applique à toute recette qui fera vibrer vos papilles sous l’action du sucre',
            hot : 'Certaines recettes sont meilleures chaudes. Avec ce Nutritag trouvez une recette qui saura vous réchauffer !',
            local : 'Ce Nutritag favorise toutes les recettes créées à partir d’aliments provenant de France métropolitaine. Le bilan carbone d’une telle recette sera beaucoup plus faible que les autres recettes en moyenne. C’est bon pour la planète ! Consommer français c’est aussi bon pour l’emploi en France !',
            season : 'Ce Nutritag favorise tous les recettes ayant des ingrédients de saison. Certains ingrédients comme les fruits et légumes frais ont une saisonnalité marquée. Manger de saison permet de faire des économies tout en préservant la planète !',
            nohob : 'Vous n’avez pas de plaques de cuisson, ou souhaitez cuisiner de façon eco-responsable ? Ce Nutritag vous propose des recettes n’utilisant pas de plaques de cuisson'
        };

        const TITLES = {
          fast : 'Recettes rapides pour les personnes qui veulent gagner du temps !',
          complicated : 'Recettes sophistiquées pour impressionner vos invités !',
          protein : 'Recettes hyperprotéinées pour prendre de la masse musculaire',
          cold : 'Recettes froides pour vous rafraîchir',
          eco : "Recettes économiques pour mettre de l'argent de côté",
          lowcarb : 'Recettes hypoglucidiques pour perdre du poids, ou pour diabétiques',
          nopig : 'Recettes sans porc',
          vegan : 'Recettes végan sans aucune ingrédient de provenance animale',
          paleo : 'Recettes paléo pour une cuisine saine et facile',
          vegetarian : 'Recettes végétariennes pour protéger la planète',
          nogluten : 'Recettes sans gluten',
          nooven : 'Recettes ne nécessitant pas de four',
          maincourse : 'Idées de recettes pour plat principal',
          nomicrowave : 'Recettes ne nécessitant pas de micro-ondes',
          entry : 'Idées de recettes pour entrée',
          pleasure : 'Idées de recettes pour se faire plaisir',
          savory : 'Idées de recettes salées',
          aperitif : "Idées de recettes pour l'apéritif",
          lowcalory : 'Idées de recettes peu caloriques pour perdre du poids',
          dessert : 'Idées de recettes pour dessert',
          sweet : 'Idées de recettes sucrées',
          hot : 'Idées de recettes chaudes pour vous réchauffer !',
          local : "Idées de recettes locales pour protéger l'environnement",
          season : "Idées de recettes de saison pour protéger la planète",
          nohob : "Idées de recettes sans plaques de cuisson"
      };

      this.wording = MATCHING_WORDING;
      this.descriptions = DESCRIPTIONS;
      this.titles = TITLES;  
         
        return this;
      }
  
  })();